<p-confirmDialog key="main" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>
<p-confirmDialog key="main2" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!--Info-->
<div class="InstructionDiv">
	<h4>Instructions:</h4>

	<div class="InstructionDetailsDiv">
		<p>Import a text or csv file then press batch email to email a registration code to all of the parents/guardians.</p>

		<p>Import Format: StudentID, Guardian Name, Guardian Email, Notify Language (Optional, English or Spanish)</p>

		<p>NOTE: It might be easier to press export, get a file, make your changes to it, and then re-import that file.</p>

		<p>After you have imported data, press Batch Email to email the guardians in the preview table. Language preferences are also updated.</p>

		<p>
			Update Languages takes the imported data and updates language preferences without sending any emails (Use this for guardians that are already
			registered)
		</p>
	</div>
</div>

<!--Buttons-->
<div class="ButtonMenu">
	<button [disabled]="IsLoading() == true" class="btn btn-primary" (click)="onImport()">Import</button>
	<button [disabled]="IsLoading() == true" class="btn btn-primary LeftMargin" (click)="onClear()">Clear Import Data</button>
	<button [disabled]="IsLoading() == true" class="btn btn-primary LeftMargin" (click)="onDownload()">Download Import Table</button>
	<button [disabled]="IsLoading() == true" class="btn btn-primary LeftMargin" (click)="onExport()">Export</button>
	<button [disabled]="IsLoading() == true" class="btn btn-success LeftMargin" (click)="onEmail()">Batch Email</button>
	<button [disabled]="IsLoading() == true" class="btn btn-info LeftMargin" (click)="onUpdateLanguages()">Update Languages</button>
</div>

<!--Error Message-->
<div class="TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
		{{ errorMessage }}
	</div>
</div>

<!--Import List Preview-->
<div>
	<p-accordion>
		<p-accordionTab
			header="Imported Data {{ ImportPreviewExpand == true ? '(Click to Collapse)' : '(Click to Expand)' }}"
			[(selected)]="ImportPreviewExpand"
		>
			<div>
				<caass-guardian-notify-import-preview [FormatOption]="FormatOption" [ImportFileData]="ImportFileData"> </caass-guardian-notify-import-preview>
			</div>
		</p-accordionTab>
	</p-accordion>
</div>

<!--Email Log Table-->
<div class="TopMarinExtra">
	<p-accordion>
		<p-accordionTab header="Email Log {{ EmailLogExpand == true ? '(Click to Collapse)' : '(Click to Expand)' }}" [(selected)]="EmailLogExpand">
			<div>
				<caass-guardian-notify-email-log> </caass-guardian-notify-email-log>
			</div>
		</p-accordionTab>
	</p-accordion>
</div>
